// extracted by mini-css-extract-plugin
export const amazon = "Amazon-module--amazon--2eoD-";
export const svg = "Amazon-module--svg--1416y";
export const text = "Amazon-module--text--2lBss";